import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatIconModule} from '@angular/material/icon';
import {ReferenceSummaryExpandedTableComponent} from './reference-summary-expanded-table.component';

@NgModule({
  imports: [CommonModule, MatIconModule, MatCheckboxModule],
  declarations: [ReferenceSummaryExpandedTableComponent],
  exports: [ReferenceSummaryExpandedTableComponent],
})
export class ReferenceSummaryExpandedTableModule {}
